import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: 'faa63be4-75d9-4b75-829c-b459aec2c9d3'
		/* ...Other Configuration Options... */
	}
});
appInsights.loadAppInsights();
appInsights.trackPageView();